import { useQuery } from "react-query";
import { fetchAllContractTypes } from "@/features/contractType/services/contractTypeService";
const useContractTypes = () => {
    const { data, error, isLoading, refetch } = useQuery("contractTypes", () => fetchAllContractTypes(), {
        staleTime: 60000,
        keepPreviousData: true,
    });
    return {
        contractTypes: data ?? [],
        loading: isLoading,
        error: error ? error.message : null,
        refetchContractTypes: refetch,
    };
};
export default useContractTypes;
